<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div class="page-wrap">

    <!-- Loading overlay -->
    <div class="loading-overlay" v-if="saveDataLoader">
      <div class="loading-card">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p v-html="loadingMessage"></p>
      </div>
    </div>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-redo"></i></div>
          <div>
            <div class="panel-title">Renew Archive</div>
            <div class="panel-sub" v-if="enrollData.applicant">
              {{ enrollData.applicant }}
              <span class="sep">•</span>
              TCN: <strong>{{ $route.params.tcn }}</strong>
              <span v-if="enrollData.archival_expiry_date" class="sep">•</span>
              <span v-if="enrollData.archival_expiry_date">
                Current expiry:
                <strong :class="isExpired(enrollData.archival_expiry_date) ? 'text-expired' : ''">
                  {{ dateFormat(enrollData.archival_expiry_date) }}
                </strong>
              </span>
            </div>
          </div>
        </div>
        <div class="panel-header-right">
          <button class="btn-back" @click="goBack()">
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>

      <!-- Payment / archival selection -->
      <div class="panel-body">
        <f-payment
          :enrollData="enrollData"
          :front_status="false"
          :is_both_card="false"
          :is_archival="true"
          :is_renew="true"
        />
      </div>

      <!-- Sticky footer -->
      <div class="panel-footer">
        <div class="footer-total" v-if="getAbbreviationCode.data.show_payment_option">
          <span class="total-label">Total</span>
          <span class="total-amount">${{ getTotalArchivalRateAmount | toFixedTwoDigit }}</span>
        </div>
        <div class="footer-actions">
          <button class="btn-cancel" @click="goBack()">
            <i class="fa fa-times"></i> Cancel
          </button>
          <button class="btn-submit" @click="SubmitService()">
            <i class="fa fa-check"></i> Submit
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment-timezone";
import { mapGetters } from "vuex";
import fPayment from "@/pages/backend/appointment/archival/payment.vue";
import {
  FETCH_F_CLIENT_ARCHIVAL_RATES,
  CHANGE_ARCHIVAL_DATE,
  FETCH_ENROLLMENT,
  FETCH_COUNTRIES,
  FETCH_STATES,
  FETCH_NOTES
} from "@/core/services/store/actions.type";
import {
  STORE_ARCHIVAL_DATE,
  SET_ARCHIVAL_PERIOD_ID,
  SET_F_CLIENT_ENABLE_ON_SITE_PAYMENT,
  SET_ARCHIVAL_RENEW_DATE,
  UPDATE_ABBREVIATION_CODE,
  SET_ARCHIVAL_TOTAL_RATE_AMOUNT,
  SET_PAYMENT_CARD_PROPERTY,
  SET_PAYMENT_CARD_TYPE,
  SET_PAYMENT_CARD_NUMBER,
  SET_PAYMENT_CARD_HOLDER_NAME,
  SET_PAYMENT_CARD_ADDRESS,
  SET_PAYMENT_CARD_CITY,
  SET_PAYMENT_CARD_CVV_NUMBER,
  SET_PAYMENT_CARD_EXPIRY_DATE,
  CARD_COUNTRY,
  CARD_STATE,
  UPDATE_PAYMENT_TYPE,
  SET_PAYMENT_CARD_NUMBER_PHONE,
  SET_PAYMENT_CARD_NUMBER_POSTAL,
  SET_CHECK_F_ABBREVIATION_CODE,
  SET_ARCHIVAL_CUSTOM_DATE,
  SET_ARCHIVAL_CUSTOM_PRICE,
  SET_ARCHIVAL_CUSTOM
} from "@/core/services/store/mutations.type";

export default {
  components: { fPayment },
  computed: {
    ...mapGetters([
      "getArchivalDate",
      "getClientId",
      "getLoadingData",
      "getTimeZone",
      "currentUser",
      "getServiceProviderData",
      "getArchivalRates",
      "getTotalServiceAmount",
      "getTotalAdditionalAmount",
      "getfClientRate",
      "getTotalRateAmount",
      "getAddQty",
      "getPromoCode",
      "getAbbreviationCode",
      "updateAbbreviationCode",
      "updatePromoCode",
      "getPaymentType",
      "getClientEnableOnSitePayment",
      "getSettingNote",
      "getPaymentCardNumber",
      "getPaymentCardHolderName",
      "getPaymentCardExpiry",
      "getPaymentCardCvvNumber",
      "getPaymentCardType",
      "getPaymentCardProperty",
      "getPaymentCardHolderAddress",
      "getPaymentCardHolderState",
      "getPaymentCardHolderCountry",
      "getPaymentCardHolderCity",
      "getStates",
      "getCountries",
      "getPaymentCardPhone",
      "getPaymentCardPostalZip",
      "getPaymentCardPhonecode",
      "getQty",
      "getTotalArchivalRateAmount",
      "getArchivalPeriodId",
      "getServiceOriCode",
      "updateServiceOriCode",
      "getServiceTypeCode",
      "getTotalDiscountAmount",
      "getPromoCodeDiscountRate",
      "getArchivalRenewDate",
      "getArchivalCustomPrice",
      "getArchivalCustomDate",
      "getArchivalCustom"
    ])
  },
  data() {
    return {
      archival_period: "",
      archivalItem: 0,
      selected_term: "",
      archival_date: "",
      set_upper_limit: "",
      set_lower_limit: "",
      enrollData: {},
      loadingMessage: "",
      saveDataLoader: false
    };
  },
  created() {
    var data_ = { enrollment_id: this.$route.params.enroll_id };
    this.$store.commit(SET_F_CLIENT_ENABLE_ON_SITE_PAYMENT, this.$route.params.onsite);
    this.reset();
    this.$store.dispatch(FETCH_COUNTRIES);
    this.$store.dispatch(FETCH_STATES);
    this.$store.dispatch(FETCH_NOTES);
    this.$store.dispatch(FETCH_ENROLLMENT, data_).then(res => {
      this.enrollData = res.data;
      this.$store.dispatch(FETCH_F_CLIENT_ARCHIVAL_RATES, res.data.originating_location_id)
        .then(data => { this.archivalData = data; });
    });
  },
  methods: {
    isExpired(date) {
      return date && new Date(date) < new Date();
    },
    dateFormat(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY");
    },
    goBack() {
      this.reset();
      this.$router.go(-1);
    },
    toFixedTwoDigit(amount) {
      return parseFloat(amount).toFixed(2);
    },
    SubmitService() {
      if (this.getArchivalCustom) {
        let custom_date = this.getArchivalCustomDate;
        let custom_price = this.getArchivalCustomPrice;
        if (custom_date == "") {
          this.$toastr.e("Please set the date");
        }
        if (custom_price == "" || custom_price == 0) {
          this.$toastr.e("Please set the required price");
        } else {
          var mytoken = document.getElementById("mytoken");
          mytoken = mytoken.innerHTML;
          if (this.getPaymentType == "C") {
            this.loadingMessage = "please wait <br> While we process your payment...";
            if (mytoken == "" || mytoken == null) {
              this.$toastr.e("The card number entered is not compliant, please check and re-enter.");
            } else {
              if (this.getIsHeartsPayment) {
                var expiremonth = document.getElementById("expiremonth").innerHTML;
                var expireyear = document.getElementById("expireyear").innerHTML;
                if (!mytoken || !expiremonth || !expireyear) {
                  this.$toastr.e("Card info is required");
                } else {
                  this.submit("submit_custom_archival");
                }
              } else {
                if (!mytoken || !this.getPaymentCardHolderName || !this.getPaymentCardExpiry || !this.getPaymentCardCvvNumber) {
                  this.$toastr.e("Card info is required");
                } else {
                  this.submit("submit_custom_archival");
                }
              }
            }
          } else {
            this.loadingMessage = "please wait <br> Your archival is being set...";
            this.submit("submit_custom_archival");
          }
        }
      } else {
        if (this.getArchivalPeriodId != "") {
          mytoken = document.getElementById("mytoken");
          mytoken = mytoken.innerHTML;
          if (this.updateAbbreviationCode != "") {
            if (!this.getAbbreviationCode.success) {
              this.$toastr.e(this.getAbbreviationCode.msg);
            } else {
              if (this.getPaymentType == "C") {
                this.loadingMessage = "please wait <br> While we process your payment...";
                if (!mytoken) {
                  this.$toastr.e("The card number entered is not compliant, please check and re-enter.");
                } else {
                  if (this.getIsHeartsPayment) {
                    expiremonth = document.getElementById("expiremonth").innerHTML;
                    expireyear = document.getElementById("expireyear").innerHTML;
                    if (!mytoken || !expiremonth || !expireyear) {
                      this.$toastr.e("Card info is required");
                    } else {
                      this.submit("submit_archival");
                    }
                  } else {
                    if (!mytoken || !this.getPaymentCardHolderName || !this.getPaymentCardExpiry || !this.getPaymentCardCvvNumber) {
                      this.$toastr.e("Card info is required");
                    } else {
                      this.submit("submit_archival");
                    }
                  }
                }
              } else {
                this.loadingMessage = "please wait <br> Your appointment is being scheduled...";
                this.submit("submit_archival");
              }
            }
          } else {
            if (this.getPaymentType == "C") {
              this.loadingMessage = "please wait <br> While we process your payment...";
              mytoken = document.getElementById("mytoken").innerHTML;
              if (!mytoken) {
                this.$toastr.e("The card number entered is not compliant, please check and re-enter.");
              } else {
                if (this.getIsHeartsPayment) {
                  var expiremonth2 = document.getElementById("expiremonth").innerHTML;
                  var expireyear2 = document.getElementById("expireyear").innerHTML;
                  if (!mytoken || !expiremonth2 || !expireyear2) {
                    this.$toastr.e("Card info is required");
                  } else {
                    this.submit("submit_archival");
                  }
                } else {
                  if (!mytoken || !this.getPaymentCardHolderName || !this.getPaymentCardExpiry || !this.getPaymentCardCvvNumber) {
                    this.$toastr.e("Card info is required");
                  } else {
                    this.submit("submit_archival");
                  }
                }
              }
            } else {
              this.loadingMessage = "please wait <br> Your appointment is being scheduled...";
              this.submit("submit_archival");
            }
          }
        } else if (this.getArchivalRenewDate == "") {
          this.$toastr.w("please select date ");
        } else {
          this.submit("submit_date");
        }
      }
    },
    reset() {
      this.$store.commit(SET_ARCHIVAL_RENEW_DATE, "");
      this.$store.commit(STORE_ARCHIVAL_DATE, "");
      this.$store.commit(SET_ARCHIVAL_PERIOD_ID, "");
      this.$store.commit(UPDATE_ABBREVIATION_CODE, "");
      this.$store.commit(SET_ARCHIVAL_TOTAL_RATE_AMOUNT, 0);
      this.$store.commit(SET_PAYMENT_CARD_PROPERTY, "");
      this.$store.commit(SET_PAYMENT_CARD_TYPE, "");
      this.$store.commit(SET_PAYMENT_CARD_NUMBER, "");
      this.$store.commit(SET_PAYMENT_CARD_HOLDER_NAME, "");
      this.$store.commit(SET_PAYMENT_CARD_ADDRESS, "");
      this.$store.commit(SET_PAYMENT_CARD_CITY, "");
      this.$store.commit(SET_PAYMENT_CARD_CVV_NUMBER, "");
      this.$store.commit(SET_PAYMENT_CARD_EXPIRY_DATE, "");
      this.$store.commit(CARD_COUNTRY, "United States");
      this.$store.commit(CARD_STATE, "");
      this.$store.commit(SET_PAYMENT_CARD_NUMBER_PHONE, "");
      this.$store.commit(SET_PAYMENT_CARD_NUMBER_POSTAL, "");
      this.$store.commit(UPDATE_PAYMENT_TYPE, "C");
      this.$store.commit(UPDATE_ABBREVIATION_CODE, "");
      this.$store.commit(SET_ARCHIVAL_CUSTOM_DATE, "");
      this.$store.commit(SET_ARCHIVAL_CUSTOM_PRICE, 0);
      this.$store.commit(SET_ARCHIVAL_CUSTOM, false);
      this.paymentMethod = true;
      this.$store.commit(SET_CHECK_F_ABBREVIATION_CODE, {
        data: { show_payment_option: true },
        success: "none"
      });
    },
    submit(submit_type) {
      this.errorMsg = "";
      let updateAbbreviationCode = this.getAbbreviationCode.data.length == 0 ? "" : this.updateAbbreviationCode;
      var formData = {
        id: this.$route.params.enroll_id,
        selected_term: this.getArchivalPeriodId,
        selected_date: this.getArchivalRenewDate,
        type: this.getPaymentType,
        abbreviation_code: updateAbbreviationCode,
        custom_archival: this.getArchivalCustom,
        custom_archival_date: this.getArchivalCustomDate,
        custom_archival_price: this.getArchivalCustomPrice
      };
      if (submit_type != "submit_date") {
        var mytoken = document.getElementById("mytoken");
        let token = mytoken.innerHTML;
        if (this.getPaymentType == "C") {
          if (this.getIsHeartsPayment) {
            var expiremonth = document.getElementById("expiremonth");
            var expireyear = document.getElementById("expireyear");
            var token_type = document.getElementById("token_type");
            var last_four = document.getElementById("last_four");
            var card_type = document.getElementById("card_type");
            formData.payment_details = {
              hearts_token: token,
              expire_month: expiremonth.innerHTML,
              expire_year: expireyear.innerHTML,
              postal: this.getPaymentCardPostalZip,
              token_type: token_type.innerHTML,
              last_four: last_four.innerHTML,
              card_type: card_type.innerHTML,
              card_address: this.getPaymentCardHolderAddress
            };
          } else {
            formData.payment_details = {
              card_number: token,
              card_holder_name: this.getPaymentCardHolderName,
              card_expiry: this.getPaymentCardExpiry,
              card_cvv_no: this.getPaymentCardCvvNumber,
              card_type: this.getPaymentCardType,
              card_address: this.getPaymentCardHolderAddress,
              card_city: this.getPaymentCardHolderCity,
              card_country: this.getPaymentCardHolderCountry,
              card_state: this.getPaymentCardHolderState,
              phone: this.getPaymentCardPhonecode.dial_code + this.getPaymentCardPhone,
              postal: this.getPaymentCardPostalZip
            };
          }
        }
      }
      var newDate = this.getArchivalCustom ? this.getArchivalCustomDate : this.getArchivalRenewDate;
      this.$swal.fire({
        title: "Are you sure?",
        text: "You want to change date to " + newDate,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#389ad4",
        cancelButtonColor: "#6b7280",
        confirmButtonText: "Yes, confirm",
        cancelButtonText: "Cancel"
      }).then(willChange => {
        if (willChange.isConfirmed) {
          this.saveDataLoader = true;
          this.$store.dispatch(CHANGE_ARCHIVAL_DATE, formData)
            .then(() => {
              this.$toastr.s("Enrollment updated successfully");
              this.saveDataLoader = false;
              this.$emit("closemodal");
              this.goBack();
            })
            .catch(err => {
              this.$toastr.e(err.data.msg);
              this.saveDataLoader = false;
            });
        }
      });
    }
  },
  filters: {
    toFixedTwoDigit: v => parseFloat(v).toFixed(2),
    timeFormat(value, date) {
      return moment(date + " " + value).format("hh:mm a");
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;
$green: #276749;

.page-wrap {
  padding: 24px;
  font-family: $font;
}

/* ── Loading overlay ── */
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(3px);
}

.loading-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 52px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(13, 27, 62, 0.2);

  i { color: $blue; }
  p {
    margin: 18px 0 0;
    font-size: 14px;
    color: $dark;
    line-height: 1.6;
  }
}

/* ── Panel card ── */
.panel-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(13, 27, 62, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 18px;
  border-bottom: 1px solid #f0f3fa;
  background: #fafbff;
  flex-wrap: wrap;
  gap: 12px;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.panel-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, $blue, #2176ae);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 15px;
  font-weight: 700;
  color: $dark;
}

.panel-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 3px;
  strong { color: $dark; font-weight: 600; }
  .sep { margin: 0 6px; color: #c5cdd8; }
}

.text-expired { color: #c62828 !important; }

.panel-header-right {
  display: flex;
  align-items: center;
}

.btn-back {
  height: 34px;
  padding: 0 14px;
  border-radius: 7px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: border-color 0.15s, color 0.15s;
  i { font-size: 12px; }
  &:hover { border-color: $blue; color: $blue; }
}

/* ── Body ── */
.panel-body {
  padding: 24px;
  flex: 1;
}

/* ── Footer ── */
.panel-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #f0f3fa;
  background: #fafbff;
  flex-wrap: wrap;
  gap: 12px;
  position: sticky;
  bottom: 0;
}

.footer-total {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.total-label {
  font-size: 12px;
  color: #8a94a6;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-weight: 600;
}

.total-amount {
  font-size: 22px;
  font-weight: 700;
  color: $dark;
}

.footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.btn-cancel {
  height: 38px;
  padding: 0 18px;
  border-radius: 8px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: border-color 0.15s, color 0.15s;
  &:hover { border-color: #c62828; color: #c62828; }
}

.btn-submit {
  height: 38px;
  padding: 0 22px;
  border-radius: 8px;
  border: none;
  background: $green;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s;
  &:hover { background: #1d5230; }
}
</style>
